import { createBrowserHistory } from 'history';

// needed to navigate from outside component
export const history = createBrowserHistory();